export default "__VITE_ASSET__87edaa2e__"